import * as React from 'react';
// NOTE: react-dates/initialize and react-dates/lib/css/_datepicker.css must be imported before react-dates
import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';
import { SingleDatePicker } from 'react-dates';
import '../../../styles/FormDatePicker.css';
import * as moment from 'moment';
import { momentDateFormat } from '../../../utilities/formatting';

interface Props {
    labelProps: {
        labelText: string;
        invalidText?: string;
    };
    inputProps: {
        id: string;
        name: string;
        placeholder?: string;
        required?: boolean;
        value?: string;
        allowAllDates?: boolean;
        disabled?: boolean;
        readOnly?: boolean;
    };
    controlCssClass?: string;
    onChange: (inputName: string, newValue: string) => void;
}

interface State {
    isFocused: boolean;
}

class FormDatePicker extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);

        this.state = {
            isFocused: false
        };

        this.datePickerChanged = this.datePickerChanged.bind(this);
    }

    render() {
        let date: moment.Moment | null = moment(this.props.inputProps.value, momentDateFormat);
        if (!date.isValid()) {
            date = null;
        }

        return (
            <div
                className={
                    'form-group form-date-picker' +
                    (this.props.controlCssClass ? ` ${this.props.controlCssClass}` : '')
                }
            >
                <label htmlFor={this.props.inputProps.id} className="font-weight-bold">
                    {this.props.labelProps.labelText}
                </label>
                {/* Input below is only for triggering HTML form validation */}
                <input
                    pattern="\d{4}-\d{2}-\d{2}"
                    className="form-control d-none"
                    required={this.props.inputProps.required}
                    value={this.props.inputProps.value || ''}
                />
                <SingleDatePicker
                    id={this.props.inputProps.id}
                    required={this.props.inputProps.required}
                    placeholder={this.props.inputProps.placeholder || 'MM/DD/YYYY'}
                    date={date}
                    onDateChange={this.datePickerChanged}
                    focused={this.state.isFocused}
                    onFocusChange={({ focused }) =>
                        this.setState({ isFocused: focused === null ? false : focused })
                    }
                    numberOfMonths={1}
                    hideKeyboardShortcutsPanel={true}
                    noBorder={true}
                    block={true}
                    readOnly={true}
                    isOutsideRange={this.props.inputProps.allowAllDates ? () => false : undefined}
                    disabled={this.props.inputProps.disabled}
                />
                {this.props.labelProps.invalidText && (
                    <div className={'invalid-feedback'}>{this.props.labelProps.invalidText}</div>
                )}
            </div>
        );
    }

    private datePickerChanged(date: moment.Moment | null) {
        this.props.onChange(this.props.inputProps.name, date ? date.format(momentDateFormat) : '');
    }
}

export default FormDatePicker;



// WEBPACK FOOTER //
// ./src/components/common/form/DatePicker.tsx